<po-page-default
  [p-breadcrumb]="breadcrumb"
  p-title="Liberação de Pedido - {{codigoPedido}}"
  [p-actions]=actions
>

  <div class="po-row">
    <div class="po-lg-12">
      <h1 class="po-font-subtitle">Dados de Pedido</h1>
      <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Tipo Pedido" p-value="{{pedido.CC5TIPO}} - {{getTipoPedidoDescricao()}}"></po-info>
      <po-info class="po-md-4 po-mt-2 po-font-text-small" p-label="Cliente" p-value="{{pedido.CC5CLIENTE}} - {{pedido.CA1NREDUZ}}"></po-info>
      <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Loja" [p-value]="pedido.CC5LOJACLI"></po-info>
      <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Transportadora" [p-value]="pedido.CC5TRANSP"></po-info>
      <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Tipo Cliente" p-value="{{pedido.CC5TIPOCLI}} - {{getTipoClienteDescricao()}}"></po-info>
      <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Cond. Pagto" [p-value]="pedido.CC5CONDPAG"></po-info>
      <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Vendedor" [p-value]="pedido.CC5VEND1"></po-info>
      <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Dt Emissão" [p-value]="pedido.DC5EMISSAO"></po-info>
      <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Tipo Frete" p-value="{{pedido.CC5TPFRETE}} - {{getTipoFreteDescricao()}}"></po-info>
      <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Volume" [p-value]="pedido.NC5VOLUME1"></po-info>
      <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Espécie" [p-value]="pedido.CC5ESPECI1"></po-info>
      <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Valor total a liberar" [p-value]="pedido.NVALORALIBERAR|currency: 'BRL'"></po-info>
      <po-info class="po-md-2 po-mt-2 po-font-text-small" p-label="Valor total do pedido" [p-value]="pedido.NVALORTOTAL|currency: 'BRL'"></po-info>
      <po-info class="po-md-4 po-mt-2 po-font-text-small" p-label="Mens. Nota 1" [p-value]="pedido.CC5MENNOTA"></po-info>
    </div>
  </div>
  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-hide-select-all]="true"
    [p-striped]="true"
    [p-columns]="colunas"
    [p-items]="pedido.items"
    p-spacing="small"
    p-container="true"
  ></po-table>
  <div class="po-lg-12 po-mt-1"><font class="po-font-text-bold" style="color: red;">Aviso: após realizar a liberação, os dados de Transportadora, Tipo Frete, Volume, Espécie e Mensagem Padrão serão alterados automaticamente.</font></div>
</po-page-default>

<po-modal #modalLiberacao p-title="Liberar Pedido" [p-primary-action]="modalLiberarAction">
  <form #f="ngForm">
    <po-textarea class="po-sm-12 po-md-12 po-lg-12"
        name="CC5MENNOTA"
        [(ngModel)]="pedido.CC5MENNOTA"
        p-rows="2"
        p-label="Mens. Nota 1:"
        p-maxlength="150"
      ></po-textarea>
      <po-select class="po-sm-12 po-md-12 po-lg-12"
        name="CATUMENPAD"
        p-label="Altera mensagem padrão?"
        [(ngModel)]="pedido.CATUMENPAD"
        [p-options]="[
          {value: 'S', label: 'Sim'},
          {value: 'N', label: 'Não'},
        ]"
      ></po-select>
      <po-select class="po-sm-6 po-md-6 po-lg-6"
        name="CTEMP40"
        p-label="Ind. de Temperatura"
        [(ngModel)]="pedido.CTEMP40"
        [p-disabled]="disableIndices"
        [p-options]="[
          {value: '0', label: 'Abaixo de 40 graus'},
          {value: '1', label: 'Acima de 40 graus'},
        ]"
      ></po-select>
      <po-select class="po-sm-6 po-md-6 po-lg-6"
        name="CTEOR1"
        p-label="Ind. de Teor de Finos"
        [(ngModel)]="pedido.CTEOR1"
        [p-disabled]="disableIndices"
        [p-options]="[
          {value: '0', label: 'Abaixo de 1%'},
          {value: '1', label: 'Acima de 1%'},
        ]"
      ></po-select>
  </form>
</po-modal>
